export function initPostTagsWrapper() {

  const loadMoreTags = document.getElementsByClassName('tags__button')[0];
  const tagsWrapper  = document.getElementsByClassName('tags__wrapper')[0];
  const tags  = document.getElementsByClassName('tags')[0];

  window.addEventListener("resize", detectVisibilityLoadMoreTags);

  function detectVisibilityLoadMoreTags() {
    const twoRowsHeight = 60;
    if (loadMoreTags && tagsWrapper)
      if (tagsWrapper.clientHeight > twoRowsHeight) {
        loadMoreTags.style.display = 'inline-block'
      } else {
        loadMoreTags.style.display = 'none'
      }
  }

  detectVisibilityLoadMoreTags();

  if (loadMoreTags) {
    loadMoreTags.addEventListener('click', (el) => {
      if(tags) {
        if(tags.classList.contains('expanded')) {
          tags.classList.remove('expanded');
          el.target.innerText = 'Pokaż więcej';
        } else {
          tags.classList.add('expanded');
          el.target.innerText = 'Pokaż mniej';
        }
      }
    });
  }

}